






















































































































































































































































import Vue from 'vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import PastLetter from '@/components/PastLetter.vue'
import Report from '@/components/interviews/Report.vue'
import PostReport from '@/components/interviews/PostReport.vue'

import { CaseLogsForInterviewReportQuery } from '@/graphql-schema'
import { CaseLogsForInterviewReport } from './Case.graphql'

import { ProcessLog } from '@/graphql-schema'
import { CaseDetails } from './Case.graphql'
import { CaseDetailsQuery } from '@/graphql-schema'
import { CaseWithMessages } from '@/queries/cases.graphql'
import { queryBookingInfoByCaseId } from '@/store/interview/queries.graphql'

import Collapsible from '@/components/layout/Collapse.vue'
import treatment from '@/routing/treatment'
import SuicidalCall from './SuicidalCall.vue'

export type CaseReport = NonNullable<CaseDetailsQuery['caseReport']>
export type Demographics = NonNullable<CaseReport['demographics']['nodes'][0]>

export default Vue.extend({
  components: {
    Artifacts,
    PastLetter,
    Report,
    PostReport,
    Collapsible,
    SuicidalCall,
  },
  apollo: {
    caseReport: {
      query: CaseDetails,
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    pickedCase: {
      query: CaseWithMessages,
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    logs: {
      query: CaseLogsForInterviewReport,
      variables() {
        return {
          id: this.$route.params.caseId
        }
      },
    },
    bookings: {
      query: queryBookingInfoByCaseId,
      variables() {
        return {
          caseId: this.caseId,
        }
      },
    },
  },
  computed: {
    firstTreatment() {
      if (this.logs && this.logs.nodes.length > 0) {
        let treatmentList = this.logs.nodes.filter(
          (i: { taskId: string }) =>
            i.taskId === 'do-cbt-treatment' ||
            i.taskId === 'do-ipt-treatment' ||
            i.taskId === 'do-expo-treatment' ||
            i.taskId === 'do-cr-treatment'
        )
        if (treatmentList.length > 0) {
          return treatmentList[0]
        }
      }
      return null
    },
    hasFinalReport(): boolean {
      return this.pickedCase?.excludeFromAnalysis != null
    },
    excludedFromAnalysis(): boolean {
      return this.pickedCase?.excludeFromAnalysis
    },
    reasonForExclusion(): string {
      return this.pickedCase?.reasonForExclusion
    },
    letters(): any[] {
      return this.$store.getters.pastLettersForMembersAndCaseId(
        this.pickedCase?.members?.node || [],
        this.caseId
      )
    },
    agreedToSuicideContract(): string {
      if (this.caseReport.patient.agreedToAntiSuicideContractAt != null) {
        return 'yes'
      }
      return 'no'
    },
    caseId(): string {
      return this.$route.params.caseId
    },
    demographics(): Demographics | undefined {
      const nodes: Demographics[] = this.caseReport?.demographics.nodes || []
      if (nodes.length === 0 || nodes[0] === undefined) {
        return undefined
      } else {
        return nodes[0]
      }
    },
    relatedTraumaliste(): any[] {
      let traumaliste = this.$store.getters['traumaliste/findBy']({ case_id: this.caseId })
      if (traumaliste != undefined && traumaliste != null) {
        //code true to X , false to -
        for (let key in traumaliste) {
          if (key.startsWith('item')) {
            if (traumaliste[key] == true) {
              traumaliste[key] = 'X'
            } else {
              traumaliste[key] = '-'
            }
          } else if (key.startsWith('is_trauma')) {
            if (traumaliste[key] == true) {
              traumaliste[key] = 'yes'
            } else {
              traumaliste[key] = 'no'
            }
          }
        }
        return [traumaliste]
      } else {
        return []
      }
    },
    interviewerName() : string {
      if (this.pickedCase?.members != null) {
        let member = this.pickedCase?.members.nodes.find(search => search.actsAsInterviewer)
        if (member != null) {
          return member.alias
        }
        return ''
      }
      return ''
    },
    interviewTerm() {
      let booking = this.bookings.nodes.find(el => el.interviewOfferByOfferId.isPost == false)

      if (booking != undefined && booking != null) {
        console.log('found booking', booking)

        let startDate = new Date(booking.interviewOfferByOfferId.timeSlot.start.value)
        let endDate = new Date(booking.interviewOfferByOfferId.timeSlot.end.value)

        return (
          startDate.toDateString() +
          ': ' +
          startDate.toLocaleTimeString() +
          ' - ' +
          endDate.toLocaleTimeString()
        )
      }
      return ''
    },
    interviewHasTakenPlace() : boolean {
      let interviewReport = this.$store.getters['interviewReports/filterBy']({
        case_id: this.caseId,
      })
      return interviewReport != undefined && interviewReport != null && interviewReport.length > 0
    },
    feedbackInterviewReportExisting(): boolean {
      let feedbackReport = this.$store.getters['feedbackInterviewReports/filterBy']({
        case_id: this.caseId,
      })
      return feedbackReport != undefined && feedbackReport != null && feedbackReport.length > 0
    },
    feedbackInteriewTerm() {
      let booking = this.bookings.nodes.find(el => el.interviewOfferByOfferId.isPost == true)
      if (booking != undefined && booking != null) {
        let startDate = new Date(booking.interviewOfferByOfferId.timeSlot.start.value)
        let endDate = new Date(booking.interviewOfferByOfferId.timeSlot.end.value)

        return (
          startDate.toDateString() +
          ': ' +
          startDate.toLocaleTimeString() +
          ' - ' +
          endDate.toLocaleTimeString()
        )
      }
      return ''
    },
    screeningEndDate(): any {
      if (this.logs && this.logs.nodes.length > 0) {
        let screeningList = this.logs.nodes.filter(
          (i: { taskId: string }) => i.taskId === 'do-screening'
        )
        if (screeningList.length > 0) {
          return this.logs.nodes[0].endedAt
        } else {
          return null
        }
      }
      return null
    },
    screeningDateFormatted() {
      let screeningDates = ''
      if (this.logs && this.logs.nodes.length > 0) {
        let screeningList = this.logs.nodes.filter(
          (i: { taskId: string }) => i.taskId === 'do-screening'
        )
        if (screeningList.length > 0) {
          let logNode = screeningList[0]
          screeningDates = new Date(logNode.startedAt).toLocaleString()
          if (logNode.endedAt) {
            screeningDates += ' / ' + new Date(logNode.endedAt).toLocaleString()
          }
        }
      }
      return screeningDates
    },
    treatmentName() {
      let treatmentName = null
      let firstTreatment = this.firstTreatment
      if (firstTreatment != null) {
        if (firstTreatment.taskId === 'do-cbt-treatment') {
          treatmentName = 'CBT'
        } else if (firstTreatment.taskId === 'do-ipt-treatment') {
          treatmentName = 'IPT'
        } else if (firstTreatment.taskId === 'do-expo-treatment') {
          treatmentName = 'EXPO'
        } else if (firstTreatment.taskId === 'do-cr-treatment') {
          treatmentName = 'CR'
        }
      }
      return treatmentName
    },
    treatmentStartDate() {
      let firstTreatment = this.firstTreatment
      if (firstTreatment != null) {
        return new Date(firstTreatment.startedAt).toLocaleString()
      }
      return ''
    },
  },
  data(): {
    phq9Fields: string[]
    caseReport: CaseReport | null
    countryNames: {
      [language: string]: { [code: number]: string }
    }
    locale: string
    traumaFields: string[]
  } {
    return {
      locale: this.$i18n.locale,
      traumaFields: [
        'created_at',
        'time_of_measurement',
        'item_1',
        'item_2',
        'item_3',
        'item_4',
        'item_5',
        'item_6',
        'item_7',
        'item_8',
        'item_9',
        'item_10',
        'item_11',
        'item_12',
        'item_13',
        'item_14',
        'item_15',
        'item_16',
        'item_17',
        'item_18',
        'item_19',
        'item_20',
        'item_21',
        'item_22',
        'item_23',
        'item_24',
        'item_25',
        'is_traumatized',
      ],
      countryNames: require('@/locales/countries.yml'),
      phq9Fields: [
        'createdAt',
        'timeOfMeasurement',
        'item1',
        'item2',
        'item3',
        'item4',
        'item5',
        'item6',
        'item7',
        'item8',
        'item9',
        'itemSeverity',
        'score',
      ],
      caseReport: null,
    }
  },
})
